export default {
      id: "oc-res-cloudaccount-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-cloudaccount",
      toString: function () {
        return this.url;
      }
    }